module.exports = __webpack_public_path__ + "ab5860d98babdc67da09b8a2ee82730a.MP3";